import type { EditControlProps } from '../../declare'
import { useState, useEffect, useContext } from 'react'
import { autorun } from 'mobx'
import { Select } from 'antd'
import { EditContext } from 'src/components'
import { appStore } from 'src/stores'

const EnumSelect = (props: EditControlProps) => {
  const edit = useContext(EditContext)

  const handleChange = (value: any) => {
    props.onChange?.(value)
  }

  const [options, setOptions] = useState([])
  useEffect(() => autorun(() => {
    const find = edit.editConfig.Nav_PageEdit?.Nav_Enums?.find((item: any) => item.EnumName === props.config.ENUM)
    if (find?.options) {
      setOptions(find.options)
    } else {
      appStore.getEnums([props.config.ENUM]).then((data: any[]) => {
        setOptions(appStore.getEnumOptions(props.config.ENUM, data))
      })
    }
  }), [props.config.ENUM])

  const { __READONLY__, EDITABLE, PROMPT_INFO } = props.config
  return (
    <Select
      allowClear
      disabled={__READONLY__ || !EDITABLE || props.evtConfig?.disabled}
      placeholder={PROMPT_INFO}
      value={props.value !== undefined ? Number(props.value) : props.value}
      options={options}
      onChange={handleChange}
    />
  )
}

export default EnumSelect